export const APP_ROUTES = {
  HOME: "",
  BRAWLERS: "brawlers",
  BRAWLER: "brawler",
  RANKEDS: "rankeds",
  MODES: "modes",
  ABOUT_US: "about-us"
};
